/*
 * Chart tokens. Recharts takes color strings; CSS custom properties resolve in
 * SVG attributes in all evergreen browsers, so the charts re-theme with the app
 * (dark/light) for free. Keep series colors to the funnel-family accents.
 */

export const ACCENT = {
  spend: 'var(--accent-spend)',
  click: 'var(--accent-click)',
  lead: 'var(--accent-lead)',
  booking: 'var(--accent-booking)',
  showup: 'var(--accent-showup)',
  close: 'var(--accent-close)',
  money: 'var(--accent-money)',
} as const;

export type AccentKey = keyof typeof ACCENT;

/** Neutral chrome for axes / grid / cursor, pulled from the theme. */
export const CHART_CHROME = {
  grid: 'var(--border)',
  axis: 'var(--fg-subtle)',
  cursor: 'var(--border-strong)',
} as const;
